export const initialState = () => ({
  listOptionsOffers: [],
  rulesOffers: {
    hasToFech: true
  },
  offersSelecteds: [],
  offersMobileSelecteds: [],
  offersTvSelecteds: [],
  paramsFilter: {},
  avaliableNumberOptions: {},
  filterCampaignSelecteds: [],
  offerBillingDiscount: {}
})
